import { Navigate, useLocation } from "react-router-dom";

export const PROFILE_SETTINGS_PATH = "/settings/profile";
export const DELETE_ACCOUNT_ANCHOR = "delete-account";

/**
 * `/settings` had a hub of links to the same pages; it now opens Profile,
 * keeping any query string and anchor the link carried.
 */
export const SettingsIndexRedirect = () => {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: PROFILE_SETTINGS_PATH, search, hash }} replace />;
};

/**
 * `/settings/account` only held Delete account, which now sits at the
 * bottom of Profile. Old links land on that card, keeping any query string
 * and anchor they carried.
 */
export const LegacyAccountSettingsRedirect = () => {
  const { search, hash } = useLocation();
  return (
    <Navigate
      to={{ pathname: PROFILE_SETTINGS_PATH, search, hash: hash || `#${DELETE_ACCOUNT_ANCHOR}` }}
      replace
    />
  );
};
